<div *ngIf="(showPristineErrors || (isDirtyOrTouched$ | async)) && (isInvalid$ | async)" class="help-block hc-error">
  {{ errorMessage$ | async }}
</div>
